module.exports = __webpack_public_path__ + "img/qian_bg_zhCn.f0eac34e.png";